import { render, staticRenderFns } from "./WebHome.vue?vue&type=template&id=72ac4b7a&"
import script from "./WebHome.vue?vue&type=script&lang=js&"
export * from "./WebHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports